import React, { useState, useEffect } from 'react';
import ControlPoint from './ControlPoint';
import sites from '../sites.json';

function AutoControlForm() {
    const [formInfo, setFormInfo] = useState({
        site: '',
        adresse: '',
        intervenant: '',
        date: new Date().toLocaleDateString('fr-FR'),
        signature: false,
        commentaires: '',
        emails: ''
    });

    const [formData, setFormData] = useState({
        tontesBordures: { before: [], after: [] },
        entretienMassifs: { before: [], after: [] },
        entretienHaies: { before: [], after: [] },
        entretienArbres: { before: [], after: [] },
        ramassageFeuilles: { before: [], after: [] },
        entretienSurfaces: { before: [], after: [] }
    });

    useEffect(() => {
        const selectedSite = sites.find(s => s.nom === formInfo.site);
        if (selectedSite) {
            setFormInfo(prev => ({ ...prev, adresse: selectedSite.adresse }));
        }
    }, [formInfo.site]);

    const updatePoint = (key, data) => {
        setFormData((prevData) => ({ ...prevData, [key]: data }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();

        Object.entries(formInfo).forEach(([key, value]) => {
            form.append(key, value);
        });

        Object.entries(formData).forEach(([key, value]) => {
            value.before.forEach((file, i) => form.append(`${key}_before[]`, file));
            value.after.forEach((file, i) => form.append(`${key}_after[]`, file));
        });

        try {
            const res = await fetch('https://jbs-autocontrol-backend.onrender.com/api/submit', {
                method: 'POST',
                body: form
            });
            const result = await res.json();
            if (result.success) alert("Formulaire envoyé avec succès !");
            else alert("Erreur lors de l'envoi.");
        } catch (err) {
            console.error(err);
            alert("Erreur de connexion au serveur.");
        }
    };

    return (
        <>
        <div className="header-container">
            <div className="header-title">
                <h1>MARCHÉ D'ENTRETIEN DES ESPACES VERTS ET ABORDS D'IMMEUBLES</h1>
                <h2>Fiche Autocontrôle</h2>
            </div>
            <div className="header-logo">
                <img src="/Normanet.png" alt="Logo Normanet" />
            </div>
        </div>
        
        <form onSubmit={handleSubmit}>
                <h2>Informations générales</h2>
                <div>
                    <label>Client :</label>
                    <input type="text" value="La Caennaise" disabled />
                </div>
                <div>
                    <label>Site / Chantier :</label>
                    <input list="sites" value={formInfo.site} onChange={e => setFormInfo({ ...formInfo, site: e.target.value })} required />
                    <datalist id="sites">
                        {sites.map(site => <option key={site.nom} value={site.nom} />)}
                    </datalist>
                </div>
                <div>
                    <label>Adresse d'intervention :</label>
                    <input type="text" value={formInfo.adresse} disabled />
                </div>
                <div>
                    <label>Date :</label>
                    <input type="text" value={formInfo.date} disabled />
                </div>
                <div>
                    <label>Intervenant :</label>
                    <input type="text" value={formInfo.intervenant} onChange={e => setFormInfo({ ...formInfo, intervenant: e.target.value })} required />
                </div>

                <h2>Points de contrôle</h2>
                <ControlPoint label="Tontes & Bordures" data={formData.tontesBordures} setData={data => updatePoint('tontesBordures', data)} />
                <ControlPoint label="Entretien des massifs / jardinières (Floralia)" data={formData.entretienMassifs} setData={data => updatePoint('entretienMassifs', data)} />
                <ControlPoint label="Entretien des haies" data={formData.entretienHaies} setData={data => updatePoint('entretienHaies', data)} />
                <ControlPoint label="Entretien des arbres" data={formData.entretienArbres} setData={data => updatePoint('entretienArbres', data)} />
                <ControlPoint label="Ramassage feuilles & bois morts" data={formData.ramassageFeuilles} setData={data => updatePoint('ramassageFeuilles', data)} />
                <ControlPoint label="Entretien des autres surfaces extérieures" data={formData.entretienSurfaces} setData={data => updatePoint('entretienSurfaces', data)} />

                <h2>Informations complémentaires</h2>
                <div>
                    <label>Observations générales :</label>
                    <textarea value={formInfo.commentaires} onChange={e => setFormInfo({ ...formInfo, commentaires: e.target.value })}></textarea>
                </div>
                <div>
                    <label><input type="checkbox" checked={formInfo.signature} onChange={e => setFormInfo({ ...formInfo, signature: e.target.checked })} /> Je certifie avoir effectué cette intervention</label>
                </div>
                <div>
                    <label>Adresses email destinataires :</label>
                    <input type="text" value={formInfo.emails} onChange={e => setFormInfo({ ...formInfo, emails: e.target.value })} placeholder="email1@mail.com, email2@mail.com" required />
                </div>

                <div className="submit-wrapper">
                    <button type="submit">Envoyer le formulaire</button>
                </div>

            </form></>
    );
}

export default AutoControlForm;
